<template>
  <span
    id="spanContainer"
    v-if="
      $store.state.snapshots.appliedSnapshot !== null &&
      Object.keys(snapshot).length !== 0
    "
  >
    <div class="workspaceHeader">
      <v-breadcrumbs :items="breadcrumbItems" divider=">">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            @click="$router.push('/' + item.href)"
            :disabled="item.disabled"
            style="font-size: 20px; color: #9c27b0; cursor: pointer;"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <div style="padding-left: 12px;">
        <span class="title" style="font-size: 1.1rem;">
          <b>{{$t('workspace.publisherUser')}}</b>
          {{
            snapshotData.checkedOutBy
              ? snapshotData.checkedOutBy.name
              : $t('commonWords.none')
          }}
        </span>
        <span style="color: #bbbbbb;">
          ({{$t('workspace.updated')}} {{ snapshotData.updatedAt }})
        </span>
      </div>
      <div style="padding-left: 12px;">
        <span class="title" style="display: block; font-size: 1.1rem;">
          <b>{{$t('workspace.versionId')}}</b>
          {{ this.$store.state.snapshots.appliedSnapshot._id }}
        </span>
      </div>
      <div style="padding-left: 12px;">
        <span class="title" style="font-size: 1.1rem;">
          {{ snapshotData.description }}
        </span>
      </div>
      <div style="padding-left: 12px; padding-top: 4px;">
        <v-chip
          small
          :color="isNotCheckedOut ? '#00bcd4' : '#ff9800'"
          dark
          label
        >
          <v-icon small dark>{{
            isNotCheckedOut ? 'visibility' : 'create'
          }}</v-icon>
          <span :style="{ padding: isNotCheckedOut ? '0 0 0 4px' : '' }">{{
            isNotCheckedOut ? 'Modo visualização' : 'Modo Edição'
          }}</span>
        </v-chip>
      </div>
    </div>
    <div
      v-if="selectNodeModeActive"
      style="
        position: fixed;
        top: 0;
        left: 80px;
        padding: 15px 15px 0 15px;
        width: 94%;
        z-index: 99999999;
      "
    >
      <md-toolbar style="z-index: 99999999;" class="md-primary">
        <h3 class="md-title" style="flex: 1;">
          {{$t('workspace.selectTargetNode')}} {{ selectNodeModeDialogTitle }})
        </h3>
        <md-button @click="onCancel()" class="md-primary">Cancelar</md-button>
      </md-toolbar>
    </div>
    <BotPageTitle style="position: relative;" />
    <div class="md-layout">
      <div class="md-layout-item" style="padding: 0;">
        <tabs
          @changed-panel="reloadSnapshot"
          :tab-name="[this.$t('workspace.dialogues'), this.$t('workspace.intentions'), this.$t('workspace.entities'), this.$t('workspace.integrations') ]"
          :tab-icon="['forum', 'priority_high', 'category', 'description']"
          class="page-subcategories"
          nav-pills-icons
          plain
          color-button="warning"
          :noTabChange='noTabChange'
        >
          <h3
            class="title text-center"
            style="font-size: 1.5rem;"
            slot="header-title"
          >
            Workspace
          </h3>
          <template slot="tab-pane-1">
            <Dialog
              :key='tabsKey'
              @isSavingDialogs='noTabChange = true'
              @savedDialogs='noTabChange = false'
              v-if="snapshot.dialog_nodes"
              v-model="snapshot.dialog_nodes"
              :intents="snapshot.intents"
              :entities="snapshot.entities"
              :viewingMode="viewingMode"
            />
          </template>
          <template slot="tab-pane-2">
            <Intents
              v-if="snapshot.intents"
              v-model="snapshot.intents"
              :viewingMode="viewingMode"
            />
          </template>
          <template slot="tab-pane-3">
            <Entitites
              v-if="snapshot.entities"
              v-model="snapshot.entities"
              :viewingMode="viewingMode"
            />
          </template>
          <template slot="tab-pane-4">
            <Integrations />
            <!-- v-if="snapshot.integrations"
            v-model="snapshot.integrations" -->
          </template>
        </tabs>
      </div>
    </div>
    <md-snackbar md-position="center" :md-active.sync="noTabChange" md-persistent>
      <span>{{$t('workspace.savingWorkspace')}}</span>
      <v-progress-circular
        indeterminate
        size="24"
        width='3'
        color='#9c27b0'
      />
    </md-snackbar>
    <v-fade-transition>
      <v-overlay :value="loading">
        <v-progress-circular
          style="display: inline-block; width: 100%;"
          indeterminate
          size="64"
        />
        <div
          style="display: inline-block; width: 100%;"
          class="h2 font-weight-thin"
        >
          {{$t('workspace.loadingWorkspace')}}
        </div>
      </v-overlay>
    </v-fade-transition>
  </span>
</template>

<script>
import Tabs from '@/components/Tabs.vue'
import BotPageTitle from '@/components/BotPageTitle.vue'
import Dialog from './Dialog.vue'
import Intents from './Intents.vue'
import Entitites from './Entitites.vue'
import Integrations from './Integrations.vue'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'

export default {
  components: {
    BotPageTitle,
    Tabs,
    Dialog,
    Intents,
    Entitites,
    Integrations
  },
  data: () => ({
    loading: true,
    snapshot: {},
    activePanel: 'Diálogos',
    tabsKey: 0,
    noTabChange: false
  }),
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    ...mapFields('dialogEdit', {
      editDialog: 'editDialog',
      customizeResponseDialog: 'customizeResponseDialog',
      selectNodeModeValue: 'selectNodeMode.value',
      selectNodeModeActive: 'selectNodeMode.active',
      selectNodeModeDialogTitle: 'selectNodeMode.dialogTitle',
      menuJump: 'selectNodeMode.menuJump'
    }),
    snapshotData () {
      return this.$store.state.snapshots.appliedSnapshot._source
    },
    ...mapGetters('snapshots', ['viewingMode', 'appliedSnapshot']),
    isNotCheckedOut () {
      return !this.$store.getters['snapshots/userCanEdit']
    },
    breadcrumbItems () {
      return [
        // {
        //   text: 'Workspaces',
        //   disabled: false,
        //   href: 'workspaces'
        // },
        {
          text: this.$t('workspace.versions'),
          disabled: false,
          href: 'snapshots'
        },
        {
          text: this.activePanel,
          disabled: true,
          href: 'workspace'
        }
      ]
    }
  },
  created () {
    if (typeof this.assistantId === typeof null) {
      Swal.fire({
        text: this.$t('workspace.pleaseSelectCognitiveAssistant'),
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      this.$router.push('/lista-assistentes')
    }
  },
  async beforeMount () {
    this.loading = true
    const minimumDelay = this.$delay(1000)
    const appliedSnapshot = this.$store.getters['snapshots/appliedSnapshot']
    const checkedOutByUser = this.$store.getters['snapshots/checkedOutByUser']
    if (!appliedSnapshot?._id && !checkedOutByUser?._id) {
      this.$router.push('/snapshots')
      return
    }
    // console.log(`appliedSnapshot`, appliedSnapshot)
    const snapshotId = appliedSnapshot?._id || checkedOutByUser?._id
    // console.log(`appliedSnapshotId`, snapshotId)
    const snapReq = await this.$axios.get(`/snapshots/${snapshotId}`)
    // console.log(`snapReq`, snapReq)
    const { data, ...snapInfo } = snapReq.data._source
    this.$store.commit('snapshots/setAppliedSnapshot', {
      _id: snapReq.data._id,
      _source: snapInfo,
      _data: data
    })
    this.snapshot = {}
    this.snapshot = data
    await minimumDelay
    this.loading = false
  },
  watch: {
    appliedSnapshot: {
      deep: true,
      handler (value) {
        this.snapshot = value._data
        this.$nextTick(() => {
          this.tabsKey += 1
        })
      }
    }
  },
  methods: {
    onCancel () {
      this.menuJump = false
      this.selectNodeModeActive = false
      this.editDialog = true
      this.$nextTick(() => {
        this.customizeResponseDialog = true
      })
      this.selectNodeModeValue = 0
    },
    async reloadSnapshot (e) {
      // temporary solution!!!
      this.activePanel = e
      const appliedSnapshot = this.$store.getters['snapshots/appliedSnapshot']
      const checkedOutByUser = this.$store.getters['snapshots/checkedOutByUser']
      if (!appliedSnapshot?._id && !checkedOutByUser?._id) {
        this.$router.push('/snapshots')
        return
      }
      const snapshotId = appliedSnapshot?._id || checkedOutByUser?._id
      const snapReq = await this.$axios.get(`/snapshots/${snapshotId}`)
      // eslint-disable-next-line
      const { data, ...snapInfo } = snapReq.data._source
      // this.$store.commit('snapshots/setAppliedSnapshot', {
      //   _id: snapReq.data._id,
      //   _source: snapInfo
      // })
      this.snapshot = data
    }
  }
}
</script>

<style scoped>
.md-card-tabs.page-subcategories > .md-card-header .title {
  margin-top: 0px !important;
  margin-bottom: 25px !important;
  min-height: 32px;
}
.md-card {
  margin: 0 !important;
}
.workspaceHeader {
  position: relative;
  height: 100px;
  top: 0;
}
</style>
